import {NotificationGateway} from '../../../../core-logic/gateways/api-services/notification-gateway';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NotificationModel} from 'src/app/core-logic/models/notification/notification-model';
import {ErrorModel} from 'src/app/core-logic/models/shared/error-model';
import {environment} from '../../../../../environments/environment';
import {Injectable} from '@angular/core';
import {UserTypeRequestOptionsModel} from '../../../../core-logic/models/shared/user-type-request-options-model';

@Injectable({providedIn: 'root'})
export class NotificationGatewayHttp implements NotificationGateway {
  constructor(private httpClient: HttpClient) {
  }

  // getBusinessCustomerNotification(requestOptions?: RequestOptionsModel): Observable<NotificationModel[] | ErrorModel> {
  //   return this.httpClient.get<NotificationModel[] | ErrorModel>(`${environment.fydlApi.url}/api/notifications/customer`);
  // }
  //
  // getBusinessMerchantNotification(requestOptions?: RequestOptionsModel): Observable<NotificationModel[] | ErrorModel> {
  //   return this.httpClient.get<NotificationModel[] | ErrorModel>(`${environment.fydlApi.url}/api/notifications/merchant`,
  //     {
  //       params: new HttpParams({fromObject: {...requestOptions } ?? {}})
  //     });
  // }

  seeNotification(notificationId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.put<boolean | ErrorModel>(`${environment.fydlApi.url}/api/notification/${notificationId}`, {});
  }

  getBusinessNotificationsByUserType(userTypeRequestOptions: UserTypeRequestOptionsModel): Observable<NotificationModel[] | ErrorModel> {
    const options = userTypeRequestOptions?.request_option?.skip ? {
      type: userTypeRequestOptions.type,
      skip: userTypeRequestOptions?.request_option?.skip
    } : { type: userTypeRequestOptions.type }
    return this.httpClient.get<NotificationModel[] | ErrorModel>(`${environment.fydlApi.url}/api/notifications`,
      {
        params: new HttpParams({fromObject: options})
      });
  }

}
